import { Route } from 'vue-router'
import { RouterNextFunction } from '@/shared/interfaces/router-next-function'

export function redirectGuard(to: Route, from: Route, next: RouterNextFunction) {
  if (to.meta.redirectTo !== undefined) {
    next(to.meta.redirectTo)
  } else {
    next()
  }
}
